require("./bootstrap");

$(document).ready(function () {
    $(".select2").select2({
        theme: "bootstrap",
    });

    $(".select2-products").select2({
        theme: "bootstrap",
        dropdownParent: "#CarrinhoModal",
    });

    $(".select-2-import-lead").select2({
        theme: "bootstrap",
        dropdownParent: "#importLeadModal",
    });

    $(".select-2-import-contract").select2({
        theme: "bootstrap",
        dropdownParent: "#importContractModal",
    });

    $(".select2-products-spdm").select2({
        theme: "bootstrap",
        dropdownParent: "#addProductModal",
    });

    $(".select2-changeLocationModal").select2({
        theme: "bootstrap",
        dropdownParent: "#changeLocationModal",
    })


    $(".select2-default").select2({});
    $(".select2-multiple").select2();

    $(".phone").mask("(00)0000-0000");
    $(".cellphone").mask("(00)00000-0000");
    $(".time").mask("00:00");
    $(".money").mask("000.000.000.000.000,00", { reverse: true });
    var options = {
        onKeyPress: function (cpf, ev, el, op) {
            var masks = ["000.000.000-000", "00.000.000/0000-00"];
            $(".document").mask(cpf.length > 14 ? masks[1] : masks[0], op);
        },
    };

    if ($(".document")?.val()?.length >= 14) {
        $(".document")?.mask("00.000.000/0000-00", options);
    } else {
        $(".document")?.mask("000.000.000-00#", options);
    }
});
